import { FC, HTMLAttributes } from "react";
import { useStyles } from "./Confetti.style";
import { useConfetti } from "../../../hooks/useConfetti";

export const Confetti: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const classes = useStyles();
  const pieces = useConfetti();

  return (
    <div {...props}>
      {pieces.map((piece) => (
        <div key={piece.id} className={classes.piece} style={piece.style} />
      ))}
    </div>
  );
};
